// Function to sanitize the file type and convert HEIC files to PNG
export const sanitizeFileType = async (rawFile: File) => {
  const oldFileName = rawFile.name;
  // Find the last dot in the file name to get the extension
  let pos = oldFileName.lastIndexOf('.');
  // If there's no dot, the file doesn't have an extension
  const oldExtension = pos !== -1 ? oldFileName.substring(pos) : '';
  if (oldExtension.toLowerCase() === '.heic') {
    try {
      // heic-convert pulls in libheif's ~1.4MB wasm-as-js bundle. Loading it here
      // rather than at module scope keeps it out of the entry chunk, so only users
      // who actually pick a HEIC file pay for it.
      const { default: heicConvert } = await import('heic-convert/browser');
      const buffer = new Uint8Array(await rawFile.arrayBuffer());
      const convertedImageBuffer = await heicConvert({
        buffer,
        format: 'PNG',
      });
      const newFileName = `${oldFileName.substring(0, pos)}.png`;
      // heic-convert declares a bare Uint8Array, which TypeScript reads as being over
      // ArrayBufferLike; BlobPart takes only a view over a plain ArrayBuffer.
      return new File([convertedImageBuffer as Uint8Array<ArrayBuffer>], newFileName, {
        type: 'image/png',
      });
    } catch (error) {
      return rawFile;
    }
  }
  return rawFile;
};
